/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  func-names,
  max-len
*/
const getBoundingClientRectForZoom = function (el, zoom) {

  // NOTE: Non-webkit based browser already return offsets and dimensions with the zoom level factored in
  // wherease webkit browsers don't, this method takes care of de-zooming those values when necessary.

  const rect = el.getBoundingClientRect();
  const webkit = (navigator.userAgent.match(/firefox|msie|trident/gi) === null);
  const m = webkit ? 1 : zoom;

  return {
    top: rect.top / m,
    right: rect.right / m,
    bottom: rect.bottom / m,
    left: rect.left / m,
    width: rect.width / m,
    height: rect.height / m,
  };
};

module.exports = {
  getBoundingClientRectForZoom,
};
